import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=0198e8d4&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=ts"
export * from "./Ratings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198e8d4",
  null
  
)

export default component.exports